import { toPng } from "html-to-image"
import type { RefObject } from "react"

const useDownloadImage = () => {
  return async (ref: RefObject<HTMLElement | null>, offerId?: string) => {
    if (!ref.current) return

    try {
      const dataUrl = await toPng(ref.current, {
        cacheBust: true,
        filter: (node) => {
          // Exclude Font Awesome <i> icons (cross-origin CSS) and any external SVG use elements
          if (node instanceof HTMLElement) {
            if (
              node.tagName.toLowerCase() === "i" &&
              node.classList.contains("fa")
            ) {
              return false
            }
          }
          return true
        },
      })
      const link = document.createElement("a")
      link.download = `oferta-${offerId}.png`
      link.href = dataUrl
      link.click()
    } catch (err) {
      console.error("Image download failed:", err)
    }
  }
}

export default useDownloadImage
